<p-tabs [value]="docKeys[0]">
    <p-tablist>
        @for (key of docKeys; track key) {
        <p-tab [value]="key">
            <span class="flex items-center gap-2">
                {{ labels[key] }} @if (!value()[key].Content) {
                <p-tag severity="secondary" value="empty" [rounded]="true" />
                }
            </span>
        </p-tab>
        }
    </p-tablist>
    <p-tabpanels>
        @for (key of docKeys; track key) {
        <p-tabpanel [value]="key">
            <app-legal-doc-view
                [doc]="value()[key]"
                [editable]="!disabled()"
                (edit)="openEdit(key)"
            />
        </p-tabpanel>
        }
    </p-tabpanels>
</p-tabs>

<app-legal-doc-edit-dialog
    [header]="editDialogHeader()"
    [(visible)]="editDialogVisible"
    [(title)]="editTitle"
    [(content)]="editContent"
    (apply)="applyEdit()"
/>
